"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var logistics = _interopRequireWildcard(require("@/api/logistics"));
var specialtyApi = _interopRequireWildcard(require("@/api/specialtyApi.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      ruleForm: {},
      loading: false,
      addresData: [],
      baseOption: [
      // 父类数据，拿列表的第一层数据，需要默认放入顶层项
      {
        name: '顶层',
        id: 0
      }]
    };
  },
  mounted: function mounted() {
    this.getCityList();
    var id = this.$route.params.id;
    if (id && id != 0) {
      this.getSpecDetail(id);
      return;
    }
    ;
    this.ruleForm = {};
  },
  methods: {
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.$set(_this.ruleForm, dataIndex, img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.ruleForm, dataIndex, '');
    },
    // 获取地区数据
    getCityList: function getCityList() {
      var _this2 = this;
      this.addresData = [];
      logistics.treeLevel3().then(function (res) {
        _this2.addresData = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
      specialtyApi.listCategroy().then(function (res) {
        _this2.baseOption = [{
          name: '顶层',
          id: 0
        }].concat(_toConsumableArray(res)) || [];
      });
    },
    // 提交保存
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this3 = this;
      this.loading = true;
      specialtyApi[this.ruleForm.id ? 'UpdateArticle' : 'AddArticle'](this.ruleForm).then(function (data) {
        _this3.$closeCompletedView();
        _this3.$message.success('操作成功');
        _this3.loading = false;
        _this3.goReturn();
      }).catch(function () {
        _this3.loading = false;
      });
    }),
    // 获取详情
    getSpecDetail: function getSpecDetail(id) {
      var _this4 = this;
      this.ruleForm = {};
      specialtyApi.getComDetail(id).then(function (res) {
        _this4.ruleForm = res;
      });
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push('/applet/specialty');
    }
  }
};